export const ASSISTANT_WELCOME_MESSAGE =
  'Olá! 👋 Sou o assistente do LinkPark. Posso ajudar você a consultar vagas e informações do estacionamento.';

export const ASSISTANT_SUGGESTIONS = [
  'Quais vagas estão disponíveis nos próximos dias?',
  'Quais são as minhas vagas?',
  'Tem pedido pendente na minha vaga?',
] as const;

export const ASSISTANT_CONVERSATION_STORAGE_KEY = 'linkpark.assistant.conversationId';

export const ASSISTANT_AVAILABLE_PERIODS_LABEL =
  'Os períodos abaixo estão disponíveis:';

export const ASSISTANT_BULK_REQUEST_HINT =
  'Se ainda precisar de uma vaga no período que você pediu, envie uma solicitação em massa para os proprietários do condomínio.';

export const ASSISTANT_BULK_REQUEST_LABEL = 'Solicitar em massa';

export const ASSISTANT_CANCEL_REQUEST_LABEL = 'Cancelar solicitação';
export const ASSISTANT_APPROVE_REQUEST_LABEL = 'Aprovar';
export const ASSISTANT_REJECT_REQUEST_LABEL = 'Rejeitar';
export const ASSISTANT_LEND_SPOT_LABEL = 'Emprestar';
export const ASSISTANT_CANCEL_WINDOW_LABEL = 'Cancelar janela';
export const ASSISTANT_CANCEL_BULK_LABEL = 'Cancelar solicitação em massa';
export const ASSISTANT_REPORT_MISUSE_LABEL = 'Reportar mau uso';
export const ASSISTANT_REPORT_MISUSE_HINT =
  'Informe a placa no formulário. A foto é opcional e ajuda a identificar o carro.';
export const ASSISTANT_RESOLVE_WILL_REMOVE_LABEL = 'Vou retirar';
export const ASSISTANT_RESOLVE_ALREADY_LABEL = 'Já resolvido';

export const ASSISTANT_NEW_CHAT_LABEL = 'Nova conversa';
export const ASSISTANT_CONVERSATIONS_LABEL = 'Conversas';
export const ASSISTANT_BACK_TO_LIST_LABEL = 'Conversas';

export function assistantReserveQuestion(count: number): string {
  return count === 1
    ? 'Você gostaria de reservar essa vaga?'
    : 'Você gostaria de reservar alguma dessas vagas?';
}

export function formatConversationTimestamp(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function conversationTitle(title: string | null, preview: string): string {
  const value = (title ?? '').trim() || preview.trim();
  return value || 'Conversa';
}

